import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const EventModal = ({ show, handleClose, eventDetails, onSave }) => {
  // Initialize formData state
  const [formData, setFormData] = useState({
    post_title: '',
    date_of_event: '',
    time_of_event: '',
    post_status: 'pending',
    select_state: '',
    select_country: ''
  });

  // Use useEffect to update formData when eventDetails changes
  useEffect(() => {
    if (eventDetails) {
      setFormData({
        post_title: eventDetails.post_title || '',
        date_of_event: eventDetails.date_of_event || eventDetails.start_date || '',
        time_of_event: eventDetails.time_of_event || eventDetails.start_time || '',
        post_status: eventDetails.post_status || 'pending',
        select_state: eventDetails.select_state || '',
        select_country: eventDetails.select_country ? eventDetails.select_country.blogname : ''
      });
    }
  }, [eventDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSave = () => {
    if (onSave) {
      onSave(formData);
    }
    handleClose(); // Close the modal after saving
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formEventTitle">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              name="post_title"
              value={formData.post_title}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formEventDate">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              name="date_of_event"
              value={formData.date_of_event}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formEventTime">
            <Form.Label>Time</Form.Label>
            <Form.Control
              type="time"
              name="time_of_event"
              value={formData.time_of_event}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formEventStatus">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              name="post_status"
              value={formData.post_status}
              onChange={handleInputChange}
            >
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formEventLocationState">
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              name="select_state"
              value={formData.select_state}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group controlId="formEventLocationCountry">
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              name="select_country"
              value={formData.select_country}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EventModal;